import { jsx as o, jsxs as V } from "react/jsx-runtime";
import { useRef as z } from "react";
import { useTranslation as C, useMasterData as m, Drawer as f, FAIcon as h, IconStyle as k, CardRadioButton as u, Theme as c, MLPVersion as _ } from "@nextgen-web-framework/all";
import '../../assets/LanguageModal.css';const b = "#ffffff", B = "#396e75", R = "#e5fdff", w = "#546223", G = "#f0fae5", O = "#a65523", p = "#fff1e8", W = "#7f3e3e", y = "#ffe2e2", v = "#62625a", P = "#f8f8e7", A = "#38539a", N = "#707070", I = "#c8f8d1", L = "#87c9c8", Y = "#5291b1", x = "rgba(82, 145, 177, 0.1019607843)", M = "#445685", S = "#181d61", T = "rgba(24, 29, 97, 0.1019607843)", j = "#5969d6", D = "#ea999d", E = "#b6577e", U = "rgba(182, 87, 126, 0.1019607843)", F = "#7e3e80", K = "#1e247f", $ = "rgba(30, 36, 127, 0.1019607843)", q = "#da7600", J = "#107f47", Q = "#d91734", X = "_html_1ige3_38", e = {
  amwayWhite: b,
  darkBlue: B,
  lightBlue: R,
  darkGreen: w,
  lightGreen: G,
  darkOrange: O,
  lightOrange: p,
  darkRed: W,
  lightRed: y,
  darkYellow: v,
  lightYellow: P,
  darkPurple: A,
  darkGrayOnWhite: N,
  dataVizColor1: I,
  dataVizColor2: L,
  dataVizColor3: Y,
  dataVizColor3Background: x,
  dataVizColor4: M,
  dataVizColor5: S,
  dataVizColor5Background: T,
  dataVizColor6: j,
  dataVizColor7: D,
  dataVizColor8: E,
  dataVizColor8Background: U,
  dataVizColor9: F,
  dataVizColor10: K,
  dataVizColor10Background: $,
  dataVizAlertOrange: q,
  dataVizSuccessGreen: J,
  dataVizWarningRed: Q,
  "no-visible": "_no-visible_1ige3_34",
  html: X,
  "drawer-header-container": "_drawer-header-container_1ige3_72",
  "back-icon-container": "_back-icon-container_1ige3_80",
  "language-modal-container": "_language-modal-container_1ige3_86",
  "lang-heading": "_lang-heading_1ige3_96"
}, oa = ({ onClose: d, currentLocale: n, languageHandler: t, hasBackButton: l = !1 }) => {
  var i;
  const s = C(), g = z(), r = m("WebshopConfigs");
  return /* @__PURE__ */ o(
    f,
    {
      header: /* @__PURE__ */ V("div", { className: e["drawer-header-container"], children: [
        l ? /* @__PURE__ */ o("div", { className: e["back-icon-container"], "data-testid": "language-back-button-test-id", "data-pod-name": "commerce", children: /* @__PURE__ */ o(h, { iconName: "angle-left", iconStyle: k.REGULAR, onClick: d }) }) : "",
        /* @__PURE__ */ o("div", { className: e["lang-heading"], children: s("web.lang") }),
        " "
      ] }),
      closeIcon: !l,
      closeOnBackdropClick: !0,
      bottomGap: 0,
      onClose: d,
      useReactPortal: !0,
      portalContainerId: "react-portal-drawer",
      children: /* @__PURE__ */ o("div", { className: e["language-modal-container"], ref: g, "data-testid": "language-modal-test-id", "data-pod-name": "commerce", children: (i = r == null ? void 0 : r.locales) == null ? void 0 : i.map((a) => /* @__PURE__ */ o(
        u,
        {
          label: a.lang,
          id: a.locale,
          name: "radioVariant",
          "data-testid": `card-radio-test-id-${a.locale}`,
          onClick: () => {
            t == null || t(a.locale);
          },
          checked: a.locale === n,
          theme: a.locale === n ? c.PURPLE : c.BLACK,
          mlpVersion: _.TWO
        },
        a.lang
      )) })
    }
  );
};
export {
  oa as default
};
//# sourceMappingURL=LanguageModal.js.map
